// extracted by mini-css-extract-plugin
export var centerText = "_e5-8";
export var container = "_e5-0";
export var doughnutContainer = "_e5-7";
export var legend = "_e5-a";
export var legendItemColorDisplay = "_e5-b";
export var legendItemLabel = "_e5-d";
export var legendItemValue = "_e5-c";
export var lg = "_e5-5";
export var maxWidth = "_e5-9";
export var md = "_e5-4";
export var responsive = "_e5-6";
export var sm = "_e5-3";
export var xs = "_e5-2";
export var xxs = "_e5-1";